import PropTypes from 'prop-types';

import {Grid, GridItem, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component} from '@amblique/king-living/app/components/contentful/component';

/**
 * TeaserTileBlock component - CF08 & CF09
 * Image Tile Block with 2-Col, 3-Col, 4-Col variants
 *
 * Uses Component wrapper to auto-fetch full TeaserTile data (including image)
 *
 * @param {Object} props - Component props
 * @param {Contentful.TeaserTileBlock} props.component - TeaserTileBlock component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const TeaserTileBlock = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {appearance, teaserTilesCollection} = component;

  const styles = useMultiStyleConfig('contentful/teaser-tile-block', {
    component,
    isComplete,
    isFetching,
    variant: appearance,
  });

  if (!teaserTilesCollection?.items?.length) {
    return null;
  }

  const validItems = teaserTilesCollection.items.filter(
    (item) => item != null && typeof item === 'object' && item.__typename && item.sys?.id
  );

  if (validItems.length === 0) {
    return null;
  }

  return (
    <Grid {...styles.container} {...props}>
      {validItems.map((item, index) => (
        <GridItem key={`${item.sys.id}-${index}`} {...styles.gridItem}>
          <Component
            component={item}
            imageWrapperStyles={styles.imageWrapperStyles}
            imageDisplayBlockStyles={styles.imageDisplayBlock}
          />
        </GridItem>
      ))}
    </Grid>
  );
};

TeaserTileBlock.displayName = 'TeaserTileBlock';
TeaserTileBlock.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
